<template>

  <span>
   {{defaultModuleCode ? defaultModuleCode :'(无)'}}
  </span>
</template>

<script>
    let win = window;
    export default {
        name: "ModuleText",
        components: {},
        props: {
            moduleCode: {
                type: String,
                default: ''
            }

        },
        watch: {
            moduleCode(val) {
                if (val) {
                    this.loadModuleTree();
                }
            }
        },

        data() {
            return {
                options: [],
                defaultModuleCode: '',
            }
        },
        computed: {


        },
        methods: {

            loadModuleTree: function () {



                let getDefaultModuleCodeValue = function (code, options, result) {


                    for (let e in options) {

                        if (options[e].value === code) {
                            result.push(options[e].label);
                            return true;

                        } else if (options[e].children && options[e].children.length > 0) {
                            if (getDefaultModuleCodeValue(code, options[e].children, result)) {
                                result.push(options[e].label);
                                return true;
                            }
                        }
                    }


                    return false;

                };


                let vm = this;
                let result = [];


                if(win.moduleOption){
                    vm.options = win.moduleOption;
                    if (vm.moduleCode) {
                        getDefaultModuleCodeValue(vm.moduleCode,win.moduleOption, result);
                        vm.defaultModuleCode = result.reverse().join(' / ');
                    }else{
                        vm.defaultModuleCode = '';
                    }

                    return ;
                }


                vm.$http.get(vm.$api.module.tree).then(function (resp) {


                    win.moduleOption = vm.options = vm.moduleTreeToModuleOption(resp.data.data.moduleTree).children;


                    if (vm.moduleCode) {
                        getDefaultModuleCodeValue(vm.moduleCode, vm.options, result);
                        vm.defaultModuleCode = result.reverse().join(' / ');
                    }


                });
            },
            moduleTreeToModuleOption: function (moduleTree) {
                let vm = this;
                let moduleOption = {};


                if (moduleTree.code) {
                    moduleOption.moduleOption = moduleTree.name;
                    moduleOption.value = moduleTree.code;
                    moduleOption.flag = moduleTree.flag;
                    moduleOption.label = moduleTree.name;
                }

                if (moduleTree.children !== null && moduleTree.children.length > 0) {
                    moduleOption.children = [];
                    moduleTree.children.forEach(function (e) {
                        moduleOption.children.push(vm.moduleTreeToModuleOption(e));
                    });
                }
                return moduleOption;
            }
        },
        created: function () {
            this.loadModuleTree();
        }
    }
</script>

<style ref="stylesheet/scss" lang="scss">


</style>